import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { t } from '../../components/common/Translate';
import { listPartner } from '../../config';
import useOffer from '../../Store/uses/useOffer';
import { Auth, recordActions } from '../../config/configuration/react';

const useCoverageRequest = (recordId) => {
  const dispatch = useDispatch();
  const autobizTradeUuid = useSelector((state) => state.reduxRecords.data[recordId])?.record?.autobizTradeUuid;
  const showPartnerVpAuto = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.vpAuto,
  );
  const showPartnerEncheresVo = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.encheresVo,
  );
  const showParnterAlcopa = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.alcopa,
  );
  const showPartnerMercier = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.mercier,
  );

  const desiredPrice = useSelector((state) => state.reduxRecords.data[recordId]?.reportExpertise?.desiredPrice);
  const record = useSelector((state) => state.reduxRecords.data[recordId]);
  const showPartner = showPartnerVpAuto || showPartnerEncheresVo || showParnterAlcopa || showPartnerMercier;

  const { offers, isOfferLoading, apiErrorMessage } = useOffer(recordId);
  const [body, setBody] = useState({
    sale_offer_type: '',
    comment: '',
    startDate: moment().format('YYYY-MM-DD'),
    startTime: moment().format('HH:mm'),
    start_date_time: moment().toISOString(),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
    endTime: moment().add(1, 'days').format('HH:mm'),
    end_date_time: moment().add(1, 'days').toISOString(),
    requested_price: desiredPrice ?? null,
    distribution_lists: [],
  });
  const [partnerBody, setPartnerBody] = useState({
    vpauto: false,
    alcopa: false,
    encheresVo: false,
    mercier: false,
    commentPartnerRequest: '',
  });
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSubmitError, setIsSubmitError] = useState(false);
  const [allowNewCouverage, setAllowNewCouverage] = useState(false);
  const appLang = Auth.preferredLanguage();
  const [display, setDisplay] = useState(true);
  const dateFormat = appLang === 'DE' ? 'DD.MM.YYYY HH:mm' : 'DD/MM/YYYY HH:mm';
  const [userGroupOptions, setUserGroupOptions] = useState([]);
  const [isOpen, setIsOpen] = useState({ group: false, history: false, alcopa: false });
  const [tooltipOpen, setTooltipOpen] = useState({
    first: false,
    second: false,
    third: false,
    fourth: false,
    fifth: false,
  });
  const [called, setCalled] = useState(false);
  const [countDown, setCountDown] = useState(null);
  const [showCountDown, setShowCountDown] = useState(null);
  const [saleInfo, setSaleInfo] = useState({});
  const [errorDate, setErrorDate] = useState(false);
  const [skipAlcopa, setSkipAlcopa] = useState(false);
  let intervalId;
  const interval = 1000;
  const isMounted = useRef(false);
  const buttonRef = useRef(null);

  if (!showPartner && saleInfo?.id !== undefined && display) {
    setAllowNewCouverage(false);
    setDisplay(false);
  }

  const openInfoBull = (target) => {
    const res = { ...tooltipOpen };
    res[target] = !res[target];
    setTooltipOpen(res);
  };

  const toggle = (model) => {
    const res = { ...isOpen };
    res[model] = !res[model];
    setIsOpen(res);
  };

  const getUserGroupFunc = async (isMountedGroup) => {
    const data = { ...body };
    if (saleInfo?.id !== undefined) return;
    const { hasGroups, id: owner } = await dispatch(recordActions.fetchGroupUserInfos());
    if (!hasGroups || isMountedGroup) return;
    if (hasGroups.length >= 1) {
      data.distribution_lists = hasGroups.map((group) => group.id);
    }
    data.owner = `/api/users/${owner}`;
    setUserGroupOptions(
      Array.isArray(hasGroups) && hasGroups.length > 0 ? hasGroups.map((i) => ({ value: i.id, label: i.name })) : [],
    );
    setBody(data);
  };

  useEffect(() => {
    setBody((prevBody) => {
      const newBody = { ...prevBody };
      let end_date_time = null;
      let start_date_time = null;

      if (newBody.endDate && newBody.endTime) {
        end_date_time = moment(`${newBody.endDate}T${newBody.endTime}`).format('YYYY-MM-DD HH:mm:ss');
        const diff = moment(end_date_time).isSameOrBefore(
          moment(`${newBody.startDate}T${newBody.startTime}`).format('YYYY-MM-DD HH:mm:ss'),
        );
        setErrorDate(diff);
        if (diff === true) {
          end_date_time = null;
        }
      }
      if (newBody.startDate && newBody.startTime) {
        start_date_time = moment(`${newBody.startDate}T${newBody.startTime}`).format('YYYY-MM-DD HH:mm:ss');
        const diff = moment(start_date_time).isSameOrAfter(
          moment(`${newBody.endDate}T${newBody.endTime}`).format('YYYY-MM-DD HH:mm:ss'),
        );
        setErrorDate(diff);
        if (diff === true) {
          start_date_time = null;
        }
      }

      return {
        ...newBody,
        end_date_time,
        start_date_time,
      };
    });
  }, [body.endDate, body.endTime, body.startDate, body.startTime]);
  useEffect(() => {
    let isMountedRef = false;
    if (saleInfo?.end_date_time) {
      if (saleInfo?.sale_status?.name === 'live') setShowCountDown(true);
      const endDateTimeSale = moment(saleInfo?.end_date_time);
      const currentTime = moment();
      let duration = moment.duration(endDateTimeSale.diff(currentTime));
      intervalId = setInterval(() => {
        let countDownSt = '';
        if (duration.isValid()) {
          // get updated duration
          duration = moment.duration(duration - interval, 'milliseconds');
          if (duration.asSeconds() <= 0) {
            clearInterval(intervalId);
            if (saleInfo?.sale_status?.name === 'live' && duration.asSeconds() > -1) window.location.reload();
            if (isMountedRef) return;
            setShowCountDown(false);
          } else {
            countDownSt =
              duration.days() > 0
                ? countDownSt.concat(' ', `${duration.days()} ${t('day')}`)
                : countDownSt.concat('', '');
            countDownSt =
              duration.hours() > 0
                ? countDownSt.concat(' ', `${duration.hours()} ${t('hours')}`)
                : countDownSt.concat('', '');
            countDownSt =
              duration.minutes() > 0
                ? countDownSt.concat(' ', `${duration.minutes()} ${t('minutes')}`)
                : countDownSt.concat('', '');
            countDownSt = countDownSt.concat(' ', `${duration.seconds()} ${t('seconds')}`);
            if (isMountedRef) return;
            setCountDown(countDownSt);
          }
        }
      }, interval);
    }
    return () => {
      isMountedRef = true;
    };
  }, [saleInfo?.end_date_time, saleInfo?.status]);

  useEffect(() => {
    let isMountedGroup = false;
    if (userGroupOptions.length === 0) getUserGroupFunc(isMountedGroup);
    return () => {
      isMountedGroup = true;
    };
  }, []);

  const getSaleId = async (vehicleId) => {
    if (vehicleId === 0 || vehicleId === null) return;
    setCalled(true);
    const res = await dispatch(recordActions.getSaleCoverage(recordId));
    if (isMounted.current) return;
    if (res?.id) setSaleInfo(res);
  };
  if (saleInfo?.id === undefined && !called) getSaleId(autobizTradeUuid);
  useEffect(() => {
    if (saleInfo?.id !== undefined) setAllowNewCouverage(true);
    return () => {
      isMounted.current = true;
    };
  }, [saleInfo?.id]);

  const checkInputSelected = () => {
    const sale_offer_type = _.get(body, 'sale_offer_type', '');
    if (userGroupOptions.length > 0) {
      if (sale_offer_type === '/api/sale_offer_types/2' && body.distribution_lists?.length > 0) return true;
      if (sale_offer_type === '') {
        if (
          _.get(partnerBody, 'vpauto') !== false ||
          _.get(partnerBody, 'alcopa', false) !== false ||
          _.get(partnerBody, 'encheresVo') !== false ||
          _.get(partnerBody, 'mercier') !== false
        )
          return true;
      } else if (
        (_.get(partnerBody, 'vpauto') !== false ||
          _.get(partnerBody, 'alcopa', false) !== false ||
          _.get(partnerBody, 'encheresVo') !== false ||
          _.get(partnerBody, 'mercier') !== false) &&
        body.distribution_lists?.length > 0
      )
        return true;
    } else {
      if (sale_offer_type === '/api/sale_offer_types/2') return true;
      if (
        _.get(partnerBody, 'vpauto') !== false ||
        _.get(partnerBody, 'alcopa', false) !== false ||
        _.get(partnerBody, 'encheresVo') !== false ||
        _.get(partnerBody, 'mercier') !== false
      )
        return true;
    }
    return false;
  };

  const createAutobizTradeId = async () => {
    if (autobizTradeUuid !== null) return autobizTradeUuid;
    const res = await dispatch(recordActions.postOffer(recordId));
    if (!res.id) return 0;
    return res.id;
  };

  const postAnnonce = async (autobizTradeId) => {
    Object.entries(body).forEach(([k, v]) => {
      const data = record;
      if (k === 'requested_price' && v === '') {
        _.set(body, `requested_price`, null);
      } else if (k === 'requested_price' && parseInt(v, 10) > 0) {
        _.set(body, `${k}`, parseInt(v, 10));
      }
      if (v === true) _.set(body, `${k}`, 1);
      if (v === false) _.set(body, `${k}`, 0);
      if (v === null && k !== 'requested_price') _.set(body, `${k}`, 0);
      if (k === 'fileNumber') {
        _.set(body, `${k}`, _.get(data, 'record.refHexaId', null));
      }
      if (k === 'start_date_time' || k === 'end_date_time') {
        const formattedDate = moment(v).format('YYYY-MM-DD HH:mm:ss');
        _.set(body, `${k}`, formattedDate);

        if (k === 'end_date_time') {
          _.set(body, 'endTime', moment(v).format('HH:mm'));
        } else if (k === 'start_date_time') {
          _.set(body, 'startTime', moment(v).format('HH:mm'));
        }
      }
    });
    const data = { ...body };
    if (autobizTradeId === null || _.get(body, 'sale_offer_type', '') === '') return;
    await dispatch(recordActions.postAnnonceAt({ ...data, vehicleId: autobizTradeId }));
  };

  const postPartnerOffer = async (autobizTradeId) => {
    if (!showPartner && autobizTradeId === null) return;
    Object.entries(partnerBody).forEach((i) => {
      if (i[0] === 'alcopa' && i[1] === true && !skipAlcopa) {
        dispatch(
          recordActions.postPartnerRequest(listPartner.alcopa, partnerBody.commentPartnerRequest, autobizTradeId),
        );
      }
      if (i[0] === 'vpauto' && i[1] === true) {
        dispatch(
          recordActions.postPartnerRequest(listPartner.vpauto, partnerBody.commentPartnerRequest, autobizTradeId),
        );
      }
      if (i[0] === 'encheresVo' && i[1] === true) {
        dispatch(
          recordActions.postPartnerRequest(listPartner.encheresVo, partnerBody.commentPartnerRequest, autobizTradeId),
        );
      }
      if (i[0] === 'mercier' && i[1] === true && !skipAlcopa) {
        dispatch(
          recordActions.postPartnerRequest(listPartner.mercier, partnerBody.commentPartnerRequest, autobizTradeId),
        );
      }
    });
  };

  const handleCreate = async () => {
    buttonRef.current.disabled = true;
    if (
      !userGroupOptions ||
      (userGroupOptions.length === 0 && _.get(body, 'sale_offer_type', '') === '/api/sale_offer_types/2')
    )
      return setIsOpen({ group: true });
    setIsSubmitLoading(true);
    try {
      const autobizTradeId = await createAutobizTradeId();
      await postAnnonce(autobizTradeId);
      await postPartnerOffer(autobizTradeId, skipAlcopa);
    } catch (e) {
      setIsSubmitError(e.message);
    } finally {
      setBody({
        ...body,
        sale_offer_type: '',
        comment: '',
      });
      setPartnerBody({
        vpauto: false,
        alcopa: false,
        encheresVo: false,
        mercier: false,
        commentPartnerRequest: '',
      });
      dispatch(recordActions.updateRecordData(recordId));
      setAllowNewCouverage(true);
      setIsSubmitLoading(false);
      setCalled(false);
      setSkipAlcopa(false);
    }
    return null;
  };

  const cancelAlcopa = () => {
    setIsOpen({ alcopa: false });
    setSkipAlcopa(true);
  };

  useEffect(() => {
    if (skipAlcopa) {
      handleCreate(skipAlcopa);
    }
  }, [skipAlcopa]);
  const handleRefresh = () => dispatch(recordActions.fetchCoverageOffers(recordId));
  if (body.distribution_lists === '') {
    if (Array.isArray(saleInfo?.distribution_lists) && saleInfo?.distribution_lists.length > 0) {
      body.distribution_lists = `/api/distribution_lists/${saleInfo?.distribution_lists[0].id}`;
    }
  }

  const inputs = {
    alert: {
      coverageIdAlreadyExits: {
        show: saleInfo?.id !== undefined && !isOfferLoading,
        label: t('coverageIdAlreadyExits'),
      },
    },
    title: t('offerToPrivateTradeTitle'),
    privateRequest: {
      label: t('privateRequest'),
      id: 'privateRequest',
      checked: body.sale_offer_type === '/api/sale_offer_types/2',
      disabled: saleInfo?.id !== undefined,
      onChange: (e) => {
        if (e.target.checked === true) {
          setBody({
            ...body,
            sale_offer_type: '/api/sale_offer_types/2',
            accept_submission: true,
            accept_auction: false,
            acceptImmediatePurchase: false,
          });
        } else {
          setBody({ ...body, sale_offer_type: '' });
        }
      },
    },
    clientPrice: {
      label: t('clientPrice'),
      id: 'clientPrice',
      value:
        saleInfo?.requested_price === null || saleInfo?.requested_price === 0
          ? ''
          : saleInfo?.requested_price ?? parseInt(body.requested_price, 10) ?? '',
      disabled: saleInfo?.id !== undefined,
      onchange: (e) => {
        setBody({
          ...body,
          requested_price: e.target.value,
        });
      },
    },
    commentCoverageRequest: {
      label: t('commentCoverageRequest'),
      id: 'commentCoverageRequest',
      value: body.comment,
      disabled: saleInfo?.id !== undefined,
      onChange: (e) => {
        setBody({
          ...body,
          comment: e.target.value,
        });
      },
    },
    userGroup: {
      show: !!(userGroupOptions && userGroupOptions.length > 0),
      value: saleInfo?.id
        ? userGroupOptions.filter((option) =>
            saleInfo?.distribution_lists?.some((group) => option.value.endsWith(group.id)),
          )
        : userGroupOptions.filter((i) => body.distribution_lists?.includes(i.value)),
      setValue: (values) => setBody({ ...body, distribution_lists: values }),
      placeholder: t('userGroup'),
      options: userGroupOptions,
      disable: saleInfo?.id !== undefined,
    },
    partnerRequest: {
      label: t('partnerRequest'),
      vpauto: {
        label: t('partnerVpauto'),
        id: 'vpauto',
        checked: partnerBody.vpauto,
        disabled: allowNewCouverage,
        onChange: (e) => {
          setPartnerBody({
            ...partnerBody,
            vpauto: e.target.checked,
          });
        },
      },
      encheresVo: {
        label: t('partnerEncheresVo'),
        id: 'encheresVo',
        checked: partnerBody.encheresVo,
        disabled: allowNewCouverage,
        onChange: (e) => {
          setPartnerBody({
            ...partnerBody,
            encheresVo: e.target.checked,
          });
        },
      },
      alcopa: {
        label: t('partnerAlcopa'),
        id: 'alcopa',
        checked: partnerBody.alcopa,
        disabled: allowNewCouverage,
        onChange: (e) => {
          setPartnerBody({
            ...partnerBody,
            alcopa: e.target.checked,
          });
        },
      },
      mercier: {
        label: t('partnerMercier'),
        id: 'mercier',
        checked: partnerBody.mercier,
        disabled: allowNewCouverage,
        onChange: (e) => {
          setPartnerBody({
            ...partnerBody,
            mercier: e.target.checked,
          });
        },
      },
    },
    commentPartnerRequest: {
      label: t('commentPartnerRequest'),
      id: 'commentPartnerRequest',
      value: partnerBody.commentPartnerRequest,
      disabled: allowNewCouverage,
      onChange: (e) => {
        setPartnerBody({
          ...partnerBody,
          commentPartnerRequest: e.target.value,
        });
      },
    },
    create: {
      label: t('send'),
      onClick: handleCreate,
      disabled: !(checkInputSelected() === true),
    },
    newCouverageBtn: {
      label: t('newCoverageRequest'),
      onClick: () => setAllowNewCouverage(false),
    },
    refresh: {
      label: t('refresh'),
      onclick: () => handleRefresh(),
    },
    endDate: {
      disabled: saleInfo?.id !== undefined,
    },
    endTime: {
      disabled: saleInfo?.id !== undefined,
    },
  };

  let selectedDate;
  let selectedTime;
  const bodyEndDate = body.endDate;
  const bodyEndTime = body.endTime;
  if (saleInfo?.id) {
    const end_date_time = moment(saleInfo?.end_date_time);
    selectedDate = moment(end_date_time).toDate();
    selectedTime = moment(end_date_time).format('HH:mm');
  } else if (bodyEndDate && bodyEndTime) {
    selectedDate = moment(bodyEndDate).toDate();
    selectedTime = bodyEndTime;
  } else {
    selectedDate = '';
    selectedTime = '';
  }

  return {
    display,
    offers,
    inputs,
    showPartner,
    allowNewCouverage,
    isSubmitLoading,
    isSubmitError,
    isOfferLoading,
    apiErrorMessage,
    dateFormat,
    toggle,
    isOpen,
    tooltipOpen,
    openInfoBull,
    countDown,
    showCountDown,
    dispatch,
    saleInfo,
    showHistory: autobizTradeUuid !== null,
    showPartnerVpAuto,
    showPartnerEncheresVo,
    showParnterAlcopa,
    showPartnerMercier,
    buttonRef,
    desiredPrice,
    errorDate,
    body,
    setBody,
    selectedDate,
    selectedTime,
    setIsOpen,
    handleCreate,
    cancelAlcopa,
    vehicle: record?.vehicle || {},
    partnerBody,
  };
};

export default useCoverageRequest;
